import Class from './c-panel';
import './c-panel@';

export default Class;